// extracted by mini-css-extract-plugin
export default {"icon":"ComponentValueChecker_icon__nimQ6","title":"ComponentValueChecker_title__zg3Y+"};